var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchFind({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".abcd123{fill:none;}.bcda321{fill:#2e65a0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "abcd123",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bcda321",
    d: "M14.546,1.868A6.374,6.374,0,1,0,20.92,8.242,6.381,6.381,0,0,0,14.546,1.868Zm0,11.248A4.874,4.874,0,1,1,19.42,8.242,4.88,4.88,0,0,1,14.546,13.116Zm-5.757-.2,1.065,1.056L5.33,18.537a.75.75,0,0,1-1.065-1.056l.535.53-.535-.53Z",
    transform: "translate(-1.048 2.132)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchFind);
export default __webpack_public_path__ + "static/media/icon-search-find.61a21468.svg";
export { ForwardRef as ReactComponent };